import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
 name: 'orderByPipe'
})
export class OrderByPipe implements PipeTransform {

 transform(array: Array<string>, args: string): Array<string> {

  // tslint:disable-next-line:curly
  if (!array || array === undefined || array.length === 0) return null;

    array.sort((a: any, b: any) => {
      if (a.date < b.date) {
        return -1;
      } else if (a.date > b.date) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }

}

@Pipe({
  name: 'reverse'
})
export class ReversePipe implements PipeTransform {

  transform(value) {
    // tslint:disable-next-line:curly
    if (!value) return;

    return value.reverse();
  }
}


@Pipe({
  name: 'newline'
})
export class NewLinePipe implements PipeTransform {

  transform(value: string, args: string[]): any {
    if (value !== undefined || value != null) {
      return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    } else {
      return value;
    }
  }
}


@Pipe({
  name: 'truncate'
})

export class TruncatePipe implements PipeTransform {

  transform(value: string, args: string[]): string {
    const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
    const trail = args.length > 1 ? args[1] : '...';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}



// WEBPACK FOOTER //
// ./src/app/seller/orderby.pipe.ts